<template>
  <div class="service-header" ref="header">
    <div class="status-bar"></div>
    <div class="nav-bar">
      <div class="back-btn" @click="handleBack">
        <img class="arrow-left" :src="backBtnImg" alt="返回" />
      </div>
      <div class="nav-actions">
        <div
          class="action-item"
          v-for="item in navActions"
          :key="item.type"
          @click="handleNavAction(item.type, item)"
        >
          <div class="icon-wrapper">
            <img class="icon" :src="item.icon" :alt="item.text" />
          </div>
          <span class="text">{{ item.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Byd from '@/utils/Byd.js'

import backBtnImg from '@/assets/image/left_back.png'
import orderCenterIcon from '@/assets/image/order_center.png'
import serviceProgressIcon from '@/assets/image/service_progress.png'
import userGuideIcon from '@/assets/image/user_guide.png'
import { track } from '@/utils/tracking.js'
const navActions = [
  {
    type: 'orderCenter',
    icon: orderCenterIcon,
    text: '订单中心',
    id: 'fe_1',
  },
  {
    type: 'serviceProgress',
    icon: serviceProgressIcon,
    text: '服务进度',
    id: 'fe_2',
  },
  {
    type: 'userGuide',
    icon: userGuideIcon,
    text: '使用手册',
    id: 'fe_3',
  },
]

export default {
  name: 'ServiceHeader',
  props: {
    topContent: {
      type: String,
      default: '小迪专属客服',
    },
    serviceProgressFeature: {
      type: Object,
      default: null,
    },
    userGuideFeature: {
      type: Object,
      default: null,
    },
    topImg: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      backBtnImg,
      navActions,
    }
  },

  methods: {
    // 返回按钮点击事件
    handleBack() {
      console.log('返回')
      Byd.navigateBack(
        {},
        {
          success: (res) => {
            console.log('调用成功:', res.data)
          },
          fail: (err) => {
            console.error('调用失败:', err.error)
          },
        },
      )
    },

    // 统一处理导航操作点击事件
    handleNavAction(type, item) {
      // 自助用户点击次数
      track({
        param: {
          cardId: item.id,
        },
      })
      switch (type) {
        case 'orderCenter':
          this.handleOrderCenter()
          break
        case 'serviceProgress':
          this.toService(this.serviceProgressFeature)
          break
        case 'userGuide':
          this.toService(this.userGuideFeature)
          break
        default:
          console.warn(`未知的导航类型: ${type}`)
      }
    },

    // 订单中心点击事件
    handleOrderCenter() {
      console.log('订单中心')
      Byd.navigateToNative(
        {
          name: 'toMyOrder',
        },
        {
          success: (res) => {
            console.log('调用成功:', res?.data)
          },
          fail: (err) => {
            console.error('调用失败:', err?.error)
          },
        },
      )
    },

    toService(feature) {
      if (feature) {
        Byd.navigateToNative({
          name: 'navigateToService',
          extend: feature,
        })
        return
      }

      this.$store.commit('showMessage', {
        message: '该功能暂未开放',
        type: 'error',
      })
    },
  },
}
</script>

<style scoped lang="less">
/* 导航栏 */
.nav-bar {
  .px2rem(height, 44);
  display: flex;
  .px2rem(padding-left, 20);
  .px2rem(padding-right, 20);
  position: relative;
  box-sizing: border-box;
  align-items: center;
}

.back-btn {
  .px2rem(width, 24);
  .px2rem(height, 24);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    .px2rem(width, 24);
    display: block;
    // .px2rem(height, 16);
  }
}

.nav-title {
  .px2rem(font-size, 16);
  font-weight: 500;
  color: #1a1d25;
  flex: 1;
}

.nav-actions {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  .px2rem(column-gap, 4);
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  .px2rem(width, 40);
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .px2rem(margin-bottom, 4);
}

.action-item .icon {
  .px2rem(width, 18);
  object-fit: contain;
}

.action-item .text {
  .px2rem(font-size, 8);
  color: #1a1d25;
}

.status-bar {
  .px2rem(height, 44);
}
</style>
